import React, { Component } from "react";
import { Button, Table, Form, Input, Divider, Select, DatePicker } from "antd";
import axios from "../../service/index";
import "./itStudy.less";
const { Option } = Select;
const { RangePicker } = DatePicker;
// const { TabPane } = Tabs;
class Userlist extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lableListData: [],
      phone: "",
      endTime: "",
      startTime: "",
      isPhone: undefined,
      total: 0,
      searchData: {
        pageNum: 1,
        pageSize: 10,
      },
      labelName: "",
      allowClear: false,
      labelId: null,
      columns: [
        {
          title: "电话号码",
          dataIndex: "phone",
          key: "phone",
          align: "center",
        },
        {
          title: "注册时间",
          dataIndex: "createdAt",
          key: "createdAt",
          align: "center",
        },
      ],
    };
  }
  async componentDidMount() {
    this.lableList();
  }
  componentWillUnmount() {
    this.setState = () => false;
  }

  lableList = () => {
    axios
      .post("userController/getAdvUserList", {
        ...this.state.searchData,
        phone: this.state.phone,
        startTime: this.state.startTime,
        endTime: this.state.endTime,
        isPhone: this.state.isPhone,
      })
      .then((res) => {
        if (res.data.code === "200") {
          this.setState({
            lableListData: res.data.data.list,
            total: res.data.data.total,
          });
        }
      });
  };

  exportData() {
    axios
      .get(
        `/userController/export?endTime=${this.state.endTime}&startTime=${this.state.startTime}`,
        { responseType: "blob" }
      )
      .then((res) => {
        const link = document.createElement("a");
        let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", "用户列表.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
  }

  render() {
    const { lableListData, columns, total } = this.state;
    const pagination = {
      showSizeChanger: true,
      total: total,
      pageSize: this.state.searchData.pageSize,
      pageSizeOptions: ["10", "20", "30", "40"],
      showTotal: () => `共 ${total} 条`,
      onShowSizeChange: (current, pageSize) => {
        let searchData = this.state.searchData;
        searchData.pageNum = current;
        searchData.pageSize = pageSize;
        this.lableList(searchData);
      },
      onChange: (current) => {
        let searchData = this.state.searchData;
        searchData.pageNum = current;
        this.lableList(searchData);
      },
    };
    return (
      <div className="userlist">
        <span style={{ display: "flex", alignItems: "center", fontSize: "18px", fontWeight: "600" }}>广告部用户管理</span>
        <Divider />
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            <Input
              allowClear
              value={this.state.phone}
              style={{ width: "160px", height: "40px", marginRight: "20px", marginBottom: "20px" }}
              placeholder="手机号码"
              onChange={(e) => {
                this.setState({
                  phone: e.target.value,
                });
              }}></Input>
            <div style={{ display: "flex", alignItems: "center", marginBottom: "20px" }}>
              <span>手机号码：</span>
              <Select
                placeholder="手机号码"
                value={this.state.isPhone}
                style={{ width: 160, height: "40px" }}
                onChange={(value) => {
                  this.setState({
                    isPhone: value,
                  });
                }}>
                <Option value={""}>全部</Option>
                <Option value={2}>有</Option>
                <Option value={1}>无</Option>
              </Select>
            </div>
            <RangePicker
              onChange={(date, dateString) => {
                console.log(date, dateString);
                this.setState({
                  startTime: dateString[0],
                  endTime: dateString[1],
                });
              }}
            />
            <Button
              className="my-button-primary"
              style={{ marginLeft: "20px" }}
              type="primary"
              onClick={() => {
                this.lableList();
              }}>
              搜索
            </Button>
            <Button
              className="my-button-primary"
              style={{ marginLeft: "20px", marginBottom: "20px" }}
              type="primary"
              onClick={() => {
                this.setState(
                  {
                    allowClear: true,
                    phone: "",
                    startTime: "",
                    endTime: "",
                    searchData: {
                      pageSize: 10,
                      pageNum: 1,
                    },
                    isPhone: undefined,
                  },
                  () => {
                    this.lableList();
                  }
                );
              }}>
              重置
            </Button>
          </div>
          {/* <div>
					<Button className='my-button-primary' style={{ marginLeft: '20px', marginBottom: '20px' }} type='primary' onClick={() => {
						this.exportData()
						}}>导出</Button>
					</div> */}
        </div>
        <Table
          pagination={pagination}
          dataSource={lableListData}
          columns={columns}
          rowKey={(record, index) => index}
          rowClassName={(record, index) => (index % 2 !== 0 ? "table-line" : "")}
        />
      </div>
    );
  }
}

export default Form.create()(Userlist);
